export interface MangoGrade {
  label: string;
  priceRange: string;
}

export interface MangoVariety {
  slug: string;
  name: string;
  displayName: string;
  tagline: string;
  description: string;
  images: string[];
  grades: MangoGrade[];
  shelfLife: string;
  badge: string;
  available: boolean;
  availabilityNote: string;
  bestFor: string;
}

export const mangoVarieties: MangoVariety[] = [
  {
    slug: 'dasheri',
    name: 'Dasheri',
    displayName: 'Dasheri Mango',
    tagline: 'Sweet, fragrant & fibre-less',
    description:
      'Dasheri is a classic sweet mango prized for its smooth, fibre-less golden pulp and rich aroma. It ripens to a warm golden-yellow and is a favourite table mango for eating fresh. Carefully hand-picked from our orchards and graded for consistent quality, Dasheri is available for bulk supply to retailers, restaurants, distributors and quick-commerce buyers.',
    images: ['/images/dasheri1.jpeg', '/images/dasheri2.jpeg'],
    grades: [
      { label: 'Medium', priceRange: '₹30/kg' },
      { label: 'Large', priceRange: '₹40–45/kg' },
      { label: 'Golden / Premium', priceRange: '₹60–70/kg' },
    ],
    shelfLife: '5–6 days',
    badge: 'Bestseller',
    available: true,
    availabilityNote: 'In season now',
    bestFor: 'Eating fresh, retail & food service',
  },
  {
    slug: 'langra',
    name: 'Langra',
    displayName: 'Langra Mango',
    tagline: 'Rich, sweet & tangy pulp',
    description:
      'Langra Aam is a much-loved variety known for its greenish skin that stays light even when fully ripe, and its rich, sweet-tangy juicy pulp. With a distinctive flavour and aroma, it is a strong seller during peak season. Sourced from our orchards and graded for size and quality, Langra is available for bulk supply to businesses, retailers and distributors.',
    images: ['/images/Langra1.jpeg', '/images/Langra2.jpeg'],
    grades: [
      { label: 'Medium', priceRange: '₹40–45/kg' },
      { label: 'Large', priceRange: '₹55–60/kg' },
    ],
    shelfLife: '4–6 days',
    badge: 'Seasonal Favourite',
    available: true,
    availabilityNote: 'In season now',
    bestFor: 'Eating fresh & juicing',
  },
  {
    slug: 'ramkela',
    name: 'Ramkela',
    displayName: 'Ramkela Mango',
    tagline: 'Firm green mango for pickling',
    description:
      'Ramkela is a firm, raw green mango grown specifically for pickling (achar). Its tart flavour, firm flesh and sturdy texture make it the preferred choice for pickle makers and food processors. Available in graded sizes and supplied fresh in bulk, Ramkela is ideal for pickle manufacturers, wholesalers and businesses needing consistent raw-mango supply.',
    images: ['/images/Ramkela1.jpeg', '/images/Ramkela2.jpeg'],
    grades: [
      { label: 'Medium', priceRange: '₹45–50/kg' },
      { label: 'Large', priceRange: '₹55/kg' },
    ],
    shelfLife: '6–7 days',
    badge: 'For Pickling',
    available: true,
    availabilityNote: 'In season now',
    bestFor: 'Pickling (achar) & food processing',
  },
  {
    slug: 'chausa',
    name: 'Chausa',
    displayName: 'Chausa Mango',
    tagline: 'Late-season, very sweet & juicy',
    description:
      'Chausa is a late-season mango celebrated for its exceptionally sweet, juicy golden pulp and rich aroma. Arriving as the main season winds down, it extends fresh mango availability into mid and late summer. Graded for size and quality, Chausa is available for bulk supply to retailers, restaurants and distributors from mid-July onwards.',
    images: ['/images/Chausa1.jpeg', '/images/Chausa2.jpeg'],
    grades: [
      { label: 'Medium', priceRange: '₹70–150/kg' },
      { label: 'Large', priceRange: '₹70–150/kg' },
    ],
    shelfLife: '5–7 days',
    badge: 'Coming Soon',
    available: false,
    availabilityNote: 'Available from mid-July',
    bestFor: 'Eating fresh & premium retail',
  },
];

export function getMangoBySlug(slug: string): MangoVariety | undefined {
  return mangoVarieties.find((m) => m.slug === slug);
}
